import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ISwitchTicCheckOutResponse,
  ISwitchTicketCheckOutData,
  ISwitchTicketOrderCompleteModal,
  ISwitchTicketOrderCompleteResponse,
  ISwitchTicketPostData,
  ISwitchTicketResponse
} from './switch-ticket';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SwitchTicketService {
  private readonly http = inject(HttpClient);

  BASE_URL = environment.apiBaseAddress;

  getPeakDayTicketDetails(
    orderIdentifier: string,
    barcodeId: string
  ): Observable<ISwitchTicketResponse> {
    return this.http
      .get<ISwitchTicketResponse>(
        `${
          this.BASE_URL
        }/Ticket/GetPeakDayTicketDetails/${orderIdentifier}/${barcodeId}`
      )
      .pipe(
        map(result => {
          return <any>Object.assign(
            {},
            {
              isSuccessful: result.isSuccessful,
              errorMessages: result.errorMessages,
              statusCode: result.statusCode,
              orderTotal: result.data.orderTotal,
              orderNumber: result.data.orderNumber,
              eventThumbnail: result.data.eventThumbnail,
              eventType: result.data.eventType,
              showId: result.data.showId,
              salesTaxData: result.data.salesTaxData,
              previousOrderItems: result.data.previousOrderItems,
              availableSections: result.data.availableSections,
              eventTitle: result.data.eventTitle,
              orderOrigin: result.data.orderOrigin
            }
          );
        })
      );
  }

  postCheckoutDataForSwithTicket(
    body: ISwitchTicketPostData
  ): Observable<ISwitchTicketCheckOutData> {
    return this.http.post<ISwitchTicketCheckOutData>(
      `${this.BASE_URL}/CheckOut/ReplaceNewItemWithExistingItem`,
      body
    );
  }

  getCheckOutDetails(
    orderIdentifier: string,
    isCashOrder: boolean = false,
    orderItemId: string = ''
  ): Observable<ISwitchTicCheckOutResponse> {
    const reqParam = {
      isCashOrder: isCashOrder,
      orderItemIdToRemove: orderItemId
    };
    return this.http.get<ISwitchTicCheckOutResponse>(
      `${
        this.BASE_URL
      }/Checkout/GetCheckOutDetailsForReplacedTickets/${orderIdentifier}`,
      { params: reqParam }
    );
  }

  removeSwitchTicketSectionFromCart(orderIdentifier: string): Observable<any> {
    return this.http.delete<any>(
      `${this.BASE_URL}/CheckOut/RemoveReplacedTickets/${orderIdentifier}`
    );
  }
  // For BA-561 other than Square Gateway
  switchTicketProcessOrder(
    body: ISwitchTicketOrderCompleteModal
  ): Observable<ISwitchTicketOrderCompleteResponse> {
    return this.http.post<ISwitchTicketOrderCompleteResponse>(
      `${this.BASE_URL}/CheckOut/ProcessReplacedOrderItem`,
      body
    );
  }
}
